import { render } from "./AssignApplications.vue?vue&type=template&id=fff7dbd4&ts=true"
import script from "./AssignApplications.vue?vue&type=script&lang=ts"
export * from "./AssignApplications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__